<template>
  <div class="roadmaps" data-testid="roadmaps">
    <div class="row">
      <div class="col-xs-12 text-center">
        <h1 class="page-heading">Roadmaps</h1>
        <p class="lead" style="margin-top: 2em; margin-bottom: 2em;">
          Roadmaps map out a student's program lesson by lesson. Each
          lesson can pin an instructor, use its own report card and
          skills, and send a document to sign when it's booked.
        </p>
      </div>
    </div>

    <div v-if="error" class="row">
      <div class="col-xs-12">
        <div class="alert alert-danger">{{ error }}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <p v-if="loading" data-testid="roadmaps-loading">Loading...</p>
        <p v-if="!loading && roadmaps.length === 0 && !error" class="alert alert-info inline"
          data-testid="roadmaps-empty">
          You have not created any Roadmaps.
        </p>

        <table v-if="!loading && roadmaps.length > 0" class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th># of Lessons</th>
              <th>Product</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="roadmap in roadmaps" :key="roadmap.id" data-testid="roadmap-row">
              <td>{{ roadmap.name }}</td>
              <td>{{ (roadmap.requirements || []).length }}</td>
              <td>{{ productName(roadmap) }}</td>
              <td>
                <button class="btn btn-dc" data-cy="drivecoach.admin.roadmaps.edit" @click="onEdit(roadmap)">
                  Edit
                </button>
                <button class="btn btn-dc btn-red" data-cy="drivecoach.admin.roadmaps.delete"
                  @click="onDelete(roadmap)">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <ActivityPagination :current-page="pagination.current_page" :last-page="pagination.last_page"
          @pagechanged="changePage" />
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="well p0 button-options">
          <div class="row">
            <div class="col-xs-6 border-right text-center pr0" @click="onCreate()">
              <div class="p10">
                <i class="fa fa-plus fa-fw fa-4x"></i>
              </div>
              <button class="btn btn-dc btn-block left" data-cy="drivecoach.admin.roadmaps.create">
                Create New Roadmap
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityPagination from '../../common/components/activity/ActivityPagination.vue';

export default {
  name: 'RoadmapsList',
  components: { ActivityPagination },
  props: {
    roadmaps: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({ current_page: 1, last_page: 1, total: 0 })
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    onPageChange: {
      type: Function,
      required: true
    },
    onCreate: {
      type: Function,
      required: true
    },
    onEdit: {
      type: Function,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    }
  },
  methods: {
    productName(roadmap) {
      const products = roadmap.product || [];
      return products.length > 0 ? products.map((product) => product.name).join(', ') : '—';
    },
    changePage(page) {
      this.onPageChange(page);
    }
  }
};
</script>
